module.exports = __webpack_public_path__ + "static/media/work-overtime-icon.47ebf630.svg";